import { useStoreItem } from "../itemStore.store";
import { sceneNodeItemStructure, useSceneNodesStore } from "../scene/sceneNodes.store";

export const useSceneMedium = useStoreItem(sceneNodeItemStructure, useSceneNodesStore, (sceneMediumRef, sceneMediumStore) => {
  return {};
});
